/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet } from "../utils/api";
import { routes } from "../utils/utils.routes";
import { PageSkeleton } from "../components/PageSkeleton";
import { PageHero } from "../components/subcomponents/PageHero";
import { FiCalendar, FiMapPin, FiArrowRight } from "react-icons/fi";
import heroImage from "../assets/images/hero-image.png";
import "../styles/events.scss";
import { UpcomingEvents } from "../components/subcomponents/UpcomingEvents";
import { formatEventDate, groupByMonth } from "../utils/utils.fucntions";

const CalI = FiCalendar as any;
const MapI = FiMapPin as any;
const ArrowI = FiArrowRight as any;

export const EventsHub: React.FC = () => {
  const [events, setEvents] = useState<EventItem[]>([]);
  const [activities, setActivities] = useState<EventItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState<"all" | "upcoming" | "past">("upcoming");

  useEffect(() => {
    Promise.all([
      apiGet("/contents", { type: "event", limit: 50 }),
      apiGet("/contents", { type: "activity", limit: 20 }),
    ])
      .then(([ev, act]) => {
        setEvents(ev.rows || []);
        setActivities(act.rows || []);
      })
      .finally(() => setLoading(false));
  }, []);

  const now = Date.now();

  const filteredEvents = useMemo(() => {
    const sorted = [...events].sort((a, b) => {
      const da = new Date(a.eventDate || a.publishedAt || a.createdAt || 0).getTime();
      const db = new Date(b.eventDate || b.publishedAt || b.createdAt || 0).getTime();
      return db - da;
    });
    if (filter === "all") return sorted;
    if (filter === "upcoming") {
      return sorted.filter((e) => {
        const t = new Date(e.eventDate || e.publishedAt || e.createdAt || 0).getTime();
        return t >= now - 86400000;
      });
    }
    return sorted.filter((e) => {
      const t = new Date(e.eventDate || e.publishedAt || e.createdAt || 0).getTime();
      return t < now - 86400000;
    });
  }, [events, filter, now]);

  const featured = filteredEvents[0] || events[0];
  const byMonth = useMemo(() => groupByMonth(filteredEvents), [filteredEvents]);

  return (
    <div className="events-hub" data-testid="events-hub">
      <PageHero
        imageCover={heroImage}
        eyebrow="Vie universitaire"
        title="Événements & calendrier"
        lead="Conférences, cérémonies, journées portes ouvertes et moments forts de la communauté ULPGL."
        tall
        breadcrumbs={[
          { label: "Accueil", href: routes.HOME },
          { label: "Événements" },
        ]}
      />

      <div className="padding-x is-layout-constrained events-body">
        {loading ? (
          <PageSkeleton />
        ) : (
          <>
            {featured && (
              <Link
                to={`${routes.ARTICLESDETAILS}/${featured.slug}`}
                className="events-featured"
                data-testid="events-featured"
              >
                <div
                  className="events-featured__visual"
                  style={{ backgroundImage: `url(${featured.coverImage || heroImage})` }}
                />
                <div className="events-featured__body">
                  <span className="events-featured__label">À la une</span>
                  <h2>{featured.title}</h2>
                  {featured.excerpt && <p>{featured.excerpt.slice(0, 200)}</p>}
                  <div className="events-featured__meta">
                    {featured.eventDate && (
                      <span>
                        <CalI size={14} />
                        {" "}
                        {formatEventDate(featured.eventDate)}
                      </span>
                    )}
                    {featured.location && (
                      <span>
                        <MapI size={14} /> {featured.location}
                      </span>
                    )}
                  </div>
                  <span className="events-featured__cta">
                    Voir les détails <ArrowI size={16} />
                  </span>
                </div>
              </Link>
            )}

            <UpcomingEvents events={filteredEvents} byMonth={byMonth} activities={activities} />
          </>
        )}
      </div>
    </div>
  );
};
